import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useApiClient } from "../../shared/customHooks";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import { useProviderContext } from "../../components/providerComponents/context/providerContext";
import ManageUserComponent from "../../components/applicationComponents/manageUserComponent.tsx/ManageUserComponent";

export default function ManageUserPage({ type }: { type: string }) {
  const { setHeaderText, id } = type == "Provider" ? useProviderContext() : useApplicationContext();
  const { fetchData } = useApiClient("UserLink", { identity: true });
  useEffect(() => {
    setHeaderText({
      value: type == "Provider" ? "Edit Provider Details" : "Edit Authorised User Details",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  const [data, setData] = useState(null);
  const { userid } = useParams();

  useEffect(() => {
    fetchData(`GetUser`, { linkId: id, id: userid }).then((res: any) => {
      setData(res.data);
    });
  }, [userid]);

  return (
    <>
      <ManageUserComponent disabled={false} data={data} type={type} />
    </>
  );
}
